// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItem-cls1__de31386ca4e361c03b6a","cls2":"CreateSocialItem-cls2___1e38cbaa059e5983c12 CreateSocialItem-cls1__de31386ca4e361c03b6a"};